// Generated by CoffeeScript 2.7.0
var TagGroup;

import BaseModel from './base_model.js';

import Tag from './tag.js';

export default TagGroup = (function() {
  class TagGroup extends BaseModel {
    constructor(attrs = {}) {
      super(attrs);
      this.tags = _.map(attrs['tags'], function(tag) {
        return new Tag(tag);
      });
    }

    toJSON() {
      return _.extend(super.toJSON(), {
        tags_attributes: _.map(this.filterTags(), function(tag) {
          return tag.toJSON();
        })
      });
    }

    destroy() {
      _.each(this.tags, function(tag) {
        return tag.destroy();
      });
      return super.destroy();
    }

    filterTags() {
      return _.filter(this.tags, function(tag) {
        return tag.isPersisted() || !tag._destroy;
      });
    }

  };

  TagGroup.setAttributes(['name']);

  return TagGroup;

}).call(this);
